/**
 * Tri stable : position persistée, puis libellé.
 */
export function compareByOrderThenLabel(
  leftOrder: number,
  leftLabel: string,
  rightOrder: number,
  rightLabel: string,
): number {
  if (leftOrder !== rightOrder) {
    return leftOrder - rightOrder
  }
  return leftLabel.localeCompare(rightLabel, 'fr')
}

function lastIdSegment(compoundId: string): string | undefined {
  const parts = compoundId.split('~')
  return parts[parts.length - 1]
}

function isUsableLib(value: string | undefined): value is string {
  return value != null && value !== '' && value.toLowerCase() !== 'null'
}

export type DomainOrderEntry = {
  domainId: string
  domLib: string
}

/**
 * Domaines dans l'ordre renvoyé par l'API (déjà trié).
 * Le domaine homonyme de la direction (CODIR) est exclu.
 */
export function domainEntriesInApiOrder(domainsId: string[], dirLib: string): DomainOrderEntry[] {
  const entries: DomainOrderEntry[] = []
  for (const domainId of domainsId) {
    const domLib = lastIdSegment(domainId)
    if (!isUsableLib(domLib) || domLib === dirLib) {
      continue
    }
    entries.push({ domainId, domLib })
  }
  return entries
}
